import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    simulationList: {},
  }
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getTreeSpecies({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.yield-table.tree_species'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getYieldTableTable({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.yield-table.table_data'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getYieldTableChart({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.yield-table.chart_data'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
